// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"41f63159","787":"dcaeec60","833":"1bf06956"}[chunkId] + ".chunk.js";
};